import { render, staticRenderFns } from "./bnkj.vue?vue&type=template&id=9252ac86&scoped=true&"
import script from "./bnkj.vue?vue&type=script&lang=js&"
export * from "./bnkj.vue?vue&type=script&lang=js&"
import style0 from "./bnkj.vue?vue&type=style&index=0&id=9252ac86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9252ac86",
  null
  
)

export default component.exports